<template>
	<div class="pix-card">
		<div class="pix-badge">
			{{ pixLabel }}
		</div>
		<div class="pix-content">
            <div class="card-section-row">
                <div class="grid-inputs-3">
                    <div>
                        <ui-input
                        v-model="responsible"
                        label="Responsável:"
                        class="responsible-input"
                    />
                    </div>
                    <div>
                        <ui-input
                        v-model="contact"
                        label="WhatsApp / E-mail:"
                        :groupicon="computedIcon"
                        :invertgroup="true"
                        class="contact-input"
                    />
                    </div>
                    <div>
                        <ui-input-money
                        v-model="value"
                        label="Valor:"
                        class="money-input"
                        prefix=''
                        group
                    />
                    </div>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import { uiInputMoney, uiInput } from '@/components/ui/form';

export default {
    components: {
        uiInputMoney,
        uiInput
    },
    props: {
        pixLabel: String,
        value: String,
        contact: String,
        responsible: String,
        icon: String
    },
    computed: {
        computedIcon() {
            if (this.icon == 'whatsapp') {
                return 'fa-brands fa-whatsapp'
            } else {
                return 'fa-thin fa-envelope'
            }
        }
    }
}
</script>

<style scoped lang="stylus">
@import './styles.styl'
</style>
